// 初始化数据
const modals = {
  submitData: {}, //基本信息数据
  uploadData: {}, //补充协议数据
  showTab: '1', //标识的tab（基本信息，补充协议）
  TaxCodeOrgName: {}, //税号和机构名称
  supplierData: '', //供应商
  personalIdentity3Key: null, //个人三要素验证key-获取验证码返回的result
  pageInfo: {}, //云签申请数据
};
export default modals;
